import { Alert, Button, Group } from '@mantine/core';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { buildSpectralAnalysisHref } from '../utils/buildGroupSessionHref';

type ReturnToAnalysisBannerProps = {
  analysisId: string;
};

export function ReturnToAnalysisBanner({
  analysisId,
}: ReturnToAnalysisBannerProps) {
  return (
    <Alert color='blue' variant='light'>
      <Group justify='space-between' wrap='wrap'>
        <span>
          Stai gestendo le sessioni per un&apos;analisi di normalizzazione
          spettrale aperta.
        </span>
        <Button
          component={Link}
          to={buildSpectralAnalysisHref(analysisId)}
          variant='light'
          size='compact-sm'
          leftSection={<ArrowLeft size={14} />}
        >
          Torna all&apos;analisi
        </Button>
      </Group>
    </Alert>
  );
}
